import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["id"]
const _hoisted_3 = ["innerHTML", "title"]
const _hoisted_4 = {
  key: 0,
  class: "popup-window__ButtonContainer"
}
const _hoisted_5 = ["src"]

import { mapModifires, type typeModifires } from "@/components/utils/modifires";
import {
  windowDialogBaseZIndex,
  windowDialogZIndexList,
  windowDialogImportantIndex,
  windowDialogAvoidOverlapList,
} from "@/components/modules/popup-window/WindowDialogState";
import {
  withDefaults,
  ref,
  Ref,
  watch,
  onMounted,
  onUnmounted,
} from "vue";
import closeIcon from "@/../public/icon/dialog/close.png";
import { ButtonItem} from "@/components/modules";
import { ExportUtil } from "@/attribute/convert/util/ExportUtil";
import { AttributeValue } from "@/attribute/convert/AttributeValue";
import { Feature } from "ol";

interface Props {
  modifires?: typeModifires;
  title?: string;
  width?: string;
  titleMaxLength?: number;
  windowId?: string;
  draggable?: boolean;
  style?: { top?: string; left?: string };
  isOpen?: boolean;
  noPadding?: boolean;
  basis?: string;
  isDisplayBase?: boolean;
  important?: boolean;
  hideHeader?: boolean;
  avoidOverlap?: boolean;
  hideClose?: boolean;
  attributeConvert?: any,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'popup-window',
  props: {
    modifires: { type: [String, Array, Boolean] },
    title: {},
    width: { default: "auto" },
    titleMaxLength: {},
    windowId: { default: "windowId" },
    draggable: { type: Boolean, default: true },
    style: {},
    isOpen: { type: Boolean },
    noPadding: { type: Boolean, default: false },
    basis: { default: "map" },
    isDisplayBase: { type: Boolean, default: false },
    important: { type: Boolean, default: false },
    hideHeader: { type: Boolean, default: false },
    avoidOverlap: { type: Boolean },
    hideClose: { type: Boolean, default: false },
    attributeConvert: {}
  },
  emits: ["closeClick"],
  setup(__props: any, { emit }) {

const props = __props;

_useCssVars(_ctx => ({
  "752162b8": (_ctx.width)
}))





const elmContentRef = ref(null);
const elmHeaderRef = ref(null);
const moving = ref(false);
const inMovableArea = ref(false);

/**
 * 自身を閉じる
 * @param e クリックイベント
 */
const closeClick = (e: Event) => {
  emit("closeClick", e);
};

/**
 * ウィンドウスタイル
 */
const windowStyle = {
  overflowX: "visible",
  overflowY: "visible",
  width: props.width,
  border: "none",
  position: props.isDisplayBase ? "fixed" : "relative",
  pointerEvents: "auto",
  left: props.isDisplayBase
    ? (window.innerWidth - Number(props.width.replace("px", ""))) / 2
    : (document.getElementById(props.basis)?.clientWidth -
        Number(props.width.replace("px", ""))) /
      2,
};

/**
 * ウィンドウエリアスタイル
 */
const windowAreaStyle: Ref<any> = ref({
  overflowX: "visible",
  overflowY: "visible",
  position: "absolute",
  pointerEvents: "none",
  zIndex: "0",
  width: "100%",
  height: "100%",
  top: "0px",
  left: props.isDisplayBase
    ? (window.innerWidth - Number(props.width.replace("px", ""))) / 2
    : (document.getElementById(props.basis)?.clientWidth -
        Number(props.width.replace("px", ""))) /
      2,
});

/**
 * ドラッグエリア定義
 */
const dragArea = ref({
  top:
    props.style?.top !== undefined
      ? Number(props.style.top.replace("px", ""))
      : props.isDisplayBase
      ? (window.innerHeight - 106) / 2
      : (document.getElementById(props.basis)?.clientHeight - 171) / 2,
  left:
    props.style?.left !== undefined
      ? Number(props.style.left.replace("px", ""))
      : props.isDisplayBase
      ? (window.innerWidth - Number(props.width.replace("px", ""))) / 2
      : (document.getElementById(props.basis)?.clientWidth -
          Number(props.width.replace("px", ""))) /
        2,
  width: document.getElementById(props.basis)?.clientWidth,
  height: 1,
});
/**
 * CSV出力
 */
const exportCsv = () => {
  const exportFileDate = ExportUtil.exportFileDate();

  const getExportValue = props.attributeConvert.getExportValue()

  const csvHeader =
  "常時観測点コード,収集時間フラグ（5分間／1時間）,観測年月日,時間帯," + 
    getExportValue
    .attributeHeader.map((ele: AttributeValue) => {
      return '"' + ele + '"';
    })
    .join(",") + "\n";
  let csvRow = "";

    getExportValue
    .attributeValues.map((ele: AttributeValue) => {
      csvRow +=
        getExportValue.feature.values_.常時観測点コード + "," +
        getExportValue.feature.values_["収集時間フラグ（5分間／1時間）"] + "," +
        ele.headerDate + "," +
        ele.headerTime + "," +
        ele.attributeValues.join(",") + "\n";
    })

  // バイトオーダーマーク：文字コードの判別（UTF-8）
  const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
  const blob = new Blob([bom, csvHeader + csvRow], { type: "text/csv" });
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  
  a.download = getExportValue
    .csvFileName.replace("yyyyMMdd_HHmmss", exportFileDate);
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};


/**
 * JSON出力
 */
const exportJson = () => {
  const exportFileDate = ExportUtil.exportFileDate();
  let getExportValue = props.attributeConvert.getExportValue()

  // "常時観測点コード","収集時間フラグ（5分間／1時間）",
  let attributeValuesArrays = [{
        key: "常時観測点コード",
        value: getExportValue.feature.values_.常時観測点コード
      },
      {
        key: "収集時間フラグ（5分間／1時間）",
        value: getExportValue.feature.values_["収集時間フラグ（5分間／1時間）"]
      },];

    getExportValue
    .attributeValues.map((ele: AttributeValue,key) => {
      attributeValuesArrays.push( 
      {
        key: "観測年月日_" + (key + 1),
        value: ele.headerDate
      },
      {
        key: "時間帯_" + (key + 1),
        value: ele.headerTime
      },
      {
        key: getExportValue.attributeHeader[0]+ "_" + (key + 1),
        value: ele.attributeValues[0]
      },
      {
        key: getExportValue.attributeHeader[1]+ "_" + (key + 1),
        value: ele.attributeValues[1]
      },
      {
        key: getExportValue.attributeHeader[2]+ "_" + (key + 1),
        value: ele.attributeValues[2]
      },
      {
        key: getExportValue.attributeHeader[3]+ "_" + (key + 1),
        value: ele.attributeValues[3]
      },
      {
        key: getExportValue.attributeHeader[4]+ "_" + (key + 1),
        value: ele.attributeValues[4]
      },
      {
        key: getExportValue.attributeHeader[5]+ "_" + (key + 1),
        value: ele.attributeValues[5]
      }
      )
    })
    getExportValue.attributeValues = attributeValuesArrays
  let featuresArray: Feature[] = [];
  let attributeValuesArray: AttributeValue[][] = [];
  getExportValue.attributeValues

  featuresArray.push(getExportValue.feature);
  attributeValuesArray.push([...getExportValue.attributeValues]);


  const jsonString = ExportUtil.toJsonFormat(
    featuresArray,
    attributeValuesArray
  );

  const blob = new Blob([jsonString], { type: "application/json" });
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = getExportValue
    .jsonFileName.replace("yyyyMMdd_HHmmss", exportFileDate);
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};

/**
 * 画面重なり制御
 */
watch(
  () => windowDialogZIndexList.value,
  () => {
    if (props.important) {
      windowAreaStyle.value.zIndex = windowDialogImportantIndex;
    } else {
      windowAreaStyle.value.zIndex =
        windowDialogBaseZIndex +
        windowDialogZIndexList.value.findIndex((ele) => {
          return ele === props.windowId;
        });
    }
  },
  { immediate: true, deep: true }
);

/**
 * 画面表示時処理
 */
watch(
  () => props.isOpen,
  () => {
    if (props.isOpen) {
      moveToFront();
      if (props.isDisplayBase) {
        moveToCenter();
      }
    }
  }
);

/**
 * 自身を最前面に移動
 */
const moveToFront = () => {
  const targetIndex = windowDialogZIndexList.value.findIndex((ele) => {
    return ele === props.windowId;
  });
  if (
    windowDialogZIndexList.value.length === 0 ||
    targetIndex !== windowDialogZIndexList.value.length - 1
  ) {
    if (targetIndex >= 0) {
      windowDialogZIndexList.value.splice(targetIndex, 1);
    }
    windowDialogZIndexList.value.push(props.windowId);
  }
};

const onDragCallback = () => {
  return () => {
    return inMovableArea.value;
  };
};

/**
 * 自身をウィンドウの中心に移動
 */
const moveToCenter = () => {
  setTimeout(() => {
    if (document.getElementById(props.windowId + "PopupWindow")) {
      dragArea.value = {
        top:
          (window.innerHeight -
            document.getElementById(props.windowId + "PopupWindow")
              .clientHeight) /
          2,
        left: (window.innerWidth - Number(props.width.replace("px", ""))) / 2,
        width: document.getElementById(props.basis)?.clientWidth,
        height: 1,
      };
    } else {
      moveToCenter();
    }
  }, 1);
};

/**
 * 初期処理
 */
onMounted(() => {
  if (props.avoidOverlap) {
    const transformList = windowDialogAvoidOverlapList.value.map((ele) => {
      return window.document.getElementById(ele).style?.transform;
    });
    const id = props.windowId + "WindowDrag";
    const element = window.document.getElementById(id);
    const regExp = new RegExp(/translate\(([0-9]+)px. ([0-9]+)px\)/);
    let i = 0;
    const buffer = 20;
    while (
      transformList.some((ele) => ele == element.style?.transform) &&
      i < 4
    ) {
      const match = element.style?.transform.match(regExp);
      if (match) {
        element.style.transform =
          "translate(" +
          (Number(match[1]) + buffer).toString() +
          "px, " +
          (Number(match[2]) + buffer).toString() +
          "px)";
      }
      dragArea.value.left += buffer;
      dragArea.value.top += buffer;
      i++;
    }
    windowDialogAvoidOverlapList.value.push(id);
  }
  moveToFront();
  if (props.draggable) {
    const elmContent = elmContentRef.value as HTMLElement;
    const elmHeader = elmHeaderRef.value as HTMLElement;
    const elm = elmContent?.parentNode;
    const elmParent = elm?.parentNode;
    if (props.hideHeader) {
      elm.addEventListener("mousedown", () => {
        moving.value = true;
        document.body.classList.add("popup-window-moving");
      });
      elm.addEventListener("mouseup", () => {
        moving.value = false;
        document.body.classList.remove("popup-window-moving");
      });
    } else {
      elmHeader.addEventListener("mousedown", () => {
        moving.value = true;
        document.body.classList.add("popup-window-moving");
      });
      elmHeader.addEventListener("mouseup", () => {
        moving.value = false;
        document.body.classList.remove("popup-window-moving");
      });
    }
    elmParent?.addEventListener("mouseover", () => {
      if (moving.value) {
        inMovableArea.value = true;
      }
    });
    elmParent?.addEventListener("mouseout", () => {
      if (moving.value) {
        inMovableArea.value = false;
      }
    });
  }
  if (props.isDisplayBase) {
    window.addEventListener("resize", moveToCenter);
    moveToCenter();
  }
});

onUnmounted(() => {
  windowDialogZIndexList.value = windowDialogZIndexList.value.filter((ele) => {
    return ele !== props.windowId;
  });
  windowDialogAvoidOverlapList.value =
    windowDialogAvoidOverlapList.value.filter((ele) => {
      return ele !== props.windowId + "WindowDrag";
    });
});

return (_ctx: any,_cache: any) => {
  const _component_draggable_resizable_vue3 = _resolveComponent("draggable-resizable-vue3")!

  return (_openBlock(), _createElementBlock("div", {
    id: props.windowId + 'WindowArea',
    style: _normalizeStyle(windowAreaStyle.value)
  }, [
    _createVNode(_component_draggable_resizable_vue3, {
      id: props.windowId + 'WindowDrag',
      dragHandle: !_ctx.hideHeader ? '#windowHeader' : null,
      style: windowStyle,
      draggable: props.draggable,
      resizable: false,
      x: dragArea.value.left,
      "onUpdate:x": _cache[0] || (_cache[0] = ($event: any) => ((dragArea.value.left) = $event)),
      y: dragArea.value.top,
      "onUpdate:y": _cache[1] || (_cache[1] = ($event: any) => ((dragArea.value.top) = $event)),
      h: dragArea.value.height,
      "onUpdate:h": _cache[2] || (_cache[2] = ($event: any) => ((dragArea.value.height) = $event)),
      onDrag: onDragCallback,
      parent: props.draggable ? '#wholeContent' : null,
      onMousedown: moveToFront
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          id: props.windowId + 'PopupWindow',
          class: _normalizeClass(_unref(mapModifires)('popup-window', _ctx.modifires)),
          style: _normalizeStyle({
          width: props.width,
        })
        }, [
          _createElementVNode("div", {
            class: "popup-window__content",
            ref_key: "elmContentRef",
            ref: elmContentRef
          }, [
            (!_ctx.hideHeader)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  id: "windowHeader",
                  class: "popup-window__header",
                  ref_key: "elmHeaderRef",
                  ref: elmHeaderRef
                }, [
                  _createElementVNode("div", {
                    class: "popup-window__ttl",
                    innerHTML: 
                _ctx.titleMaxLength && _ctx.title.length > _ctx.titleMaxLength
                  ? _ctx.title.substring(0, _ctx.titleMaxLength) + '…'
                  : _ctx.title
              ,
                    title: 
                _ctx.titleMaxLength && _ctx.title.length > _ctx.titleMaxLength ? _ctx.title : null
              
                  }, null, 8, _hoisted_3),
                  (_ctx.windowId === `realTimeTraffic`)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createVNode(_unref(ButtonItem), { onClick: exportCsv }, {
                          default: _withCtx(() => [
                            _createTextVNode("CSV出力")
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(ButtonItem), { onClick: exportJson }, {
                          default: _withCtx(() => [
                            _createTextVNode("GeoJSON出力")
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (!props.hideClose)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "popup-window__close",
                        onClick: closeClick,
                        type: "button"
                      }, [
                        _createElementVNode("img", {
                          class: "popup-window__close_img",
                          src: _unref(closeIcon)
                        }, null, 8, _hoisted_5)
                      ]))
                    : _createCommentVNode("", true)
                ], 512))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["popup-window__body", { noPadding: props.noPadding }])
            }, [
              _renderSlot(_ctx.$slots, "main-content")
            ], 2)
          ], 512)
        ], 14, _hoisted_2)
      ]),
      _: 3
    }, 8, ["id", "dragHandle", "draggable", "x", "y", "h", "parent"])
  ], 12, _hoisted_1))
}
}

})